<template>
  <div class="mx-auto w-full max-w-screen-2xl px-4">
    <slot />
  </div>
</template>